/**
 * This accepts an "unknown" since it can handle any kind of type,
 * but it usually expects a string or number
 */
export const addCommas = function (arg: unknown) {
    const nStr = arg + '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
};

export function stripCommas(numString: unknown) {
    return (typeof numString === 'string') ? numString.replace(/,/g, '') : numString as string;
}

export function parseInteger(numString: unknown) {
    return Math.round(parseInt(stripCommas(numString), 10));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isInteger(num: any) {
    return !isNaN(num) && (function (x) { return (x | 0) === x; })(parseFloat(num));
}

export function isPositiveDollarAmount(amount: string | nullish) {
    if (amount == null || window.trim(amount) === '') {
        return false;
    }
    const donAmt = amount.replace(/[$ ,]/g, '');
    const regexp = /^[0-9.]+$/;
    return !(donAmt.match(regexp) == null || parseFloat(donAmt) <= 0);
}

export function isNonNegativeDollarAmount(amount: string | nullish) {
    if (amount == null || window.trim(amount) === '') {
        return false;
    }
    const donAmt = amount.replace(/[$ ,]/g, '');
    const regexp = /^[0-9.]+$/;
    return !(donAmt.match(regexp) == null || parseFloat(donAmt) < 0);
}
